/**
 * Modal Context
 * Global modal state management for task and branch details
 */

import React, { createContext, useState, useContext } from 'react';

const ModalContext = createContext(null);

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};

export const ModalProvider = ({ children }) => {
  const [taskModalId, setTaskModalId] = useState(null);
  const [branchModalId, setBranchModalId] = useState(null);

  const openTaskModal = (taskId) => {
    setTaskModalId(taskId);
  };

  const closeTaskModal = () => {
    setTaskModalId(null);
  };

  const openBranchModal = (branchId) => {
    setBranchModalId(branchId);
  };

  const closeBranchModal = () => {
    setBranchModalId(null);
  };

  const value = {
    taskModalId,
    branchModalId,
    openTaskModal,
    closeTaskModal,
    openBranchModal,
    closeBranchModal,
  };

  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>;
};

export default ModalContext;
